<template>
  <button
    :type="type"
    :class="[baseClasses]"
    :disabled="disabled"
  >
      <div class="border border-solid border-gray-light rounded-[50%] w-[40px] h-[40px] flex items-center justify-center flex-col">
        <slot name="icon-after"></slot>
      </div>
      <slot></slot>
  </button>
</template>

<script>
import IconLoader from '@/components/icons/IconLoader';

export default {
  name: 'IconButton',
  components: {
    IconLoader,
  },
  props: {
    type: {
      type: String,
      default: 'button',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    state: {
      type: String,
      validator: function (value) {
        return ['default', 'active', 'cannot-remove'].includes(value);
      },
      default: 'default',
    },
  },
  computed: {
    baseClasses() {
      const base = 'border border-solid rounded-[10px] p-2 flex gap-2 flex-col items-center justify-center w-full text-[14px] transition-colors leading-tight min-h-[69px] md:min-h-[99px]';
      const stateClasses = {
        'default': 'border-gray-light hover:border-gray-dark hover:bg-gray-10',
        'active': 'border-turquoise-60 bg-turquoise-10',
        'cannot-remove': 'border-gray-light opacity-50 cursor-not-allowed'
      };
      return `${base} ${stateClasses[this.state]}`;
    },
  },
};
</script>
